export enum LoadingSpinnerPositionEnum {
    Center,
    Left,
    Right,
    Top
}